import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Button, Col, Input, Label, Row } from "reactstrap";
import { FaEdit } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { setSelectedPrice } from "../../../redux/slices/MsgSlice";

const ServicePackageCreation = ({
  selectedPackages,
  handlePackageSelection,
  totalPrice,
  packageName,
  packageToEdit,
  handleSaveEditedPackage,
  handleItemClick,
  handleCreatePackage,
  packageNameRef,
  totalPriceRef,
  setGuestCount,
  guestCount,
  state,
  checked,
}) => {
  const [editPackageName, setEditPackageName] = useState(false);
  const [editTotalPrice, setEditTotalPrice] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        packageNameRef.current &&
        !packageNameRef.current.contains(event.target)
      ) {
        setEditPackageName(false);
      }
      if (
        totalPriceRef.current &&
        !totalPriceRef.current.contains(event.target)
      ) {
        setEditTotalPrice(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handlePackageType = () => {
    if (state?.invoice) {
      if (checked) {
        dispatch(setSelectedPrice(totalPriceRef.current.textContent));
      } else {
        dispatch(setSelectedPrice(totalPriceRef.current.textContent));
      }
    } else {
      handleCreatePackage();
    }
  };

  return (
    <div className="service-package-container">
      <div className="service-package-title">Service Package Creation</div>
      <div className="service-package-card">
        <Row>
          <Col lg={9} md={8} sm={12}>
            <div className="service-package-content">
              <div className="service-package-header">
                <span
                  className="service-package-name"
                  contentEditable={editPackageName}
                  ref={packageNameRef}
                >
                  {packageName ? packageName : "Package Name"}
                </span>
                {!editPackageName && (
                  <FaEdit
                    className="service-package-edit-icon"
                    onClick={() => {
                      setTimeout(() => {
                        packageNameRef.current.focus();
                      }, 0);
                      setEditPackageName(true);
                    }}
                    size={18}
                  />
                )}
              </div>
              <div className="service-package-items">
                <Row>
                  {Object.keys(selectedPackages).map((key, index) => (
                    <Col
                      key={index}
                      xs={12}
                      sm={6}
                      md={6}
                      lg={4}
                      className="my-2"
                    >
                      <div
                        className="service-package-item"
                        onClick={() => handleItemClick(key, index)}
                      >
                        <Input
                          type="checkbox"
                          className="mt-1"
                          checked={selectedPackages[key].checked}
                          disabled
                          onChange={() =>
                            handlePackageSelection(
                              selectedPackages[key].Id,
                              index,
                              {
                                ...selectedPackages[key],
                                checked: !selectedPackages[key].checked,
                              }
                            )
                          }
                        />
                        <span className="ms-2">
                          <span className="service-package-item-title">
                            {selectedPackages[key].title}
                          </span>
                          <p className="service-package-item-description">
                            {selectedPackages[key].description}
                          </p>
                        </span>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          </Col>
          <Col lg={3} md={4} sm={12} className="service-package-info-panel">
            <div>
              <Label>Select Guest Count</Label>
              <Input
                type="select"
                name="guestCount"
                className="service-package-guest-select"
                value={guestCount}
                onChange={(e) => setGuestCount(e.target.value)}
              >
                {Array.from({ length: 17 }, (_, index) => (
                  <option key={index} value={index * 50}>
                    {index * 50}
                  </option>
                ))}
              </Input>
            </div>
            <div className="service-package-total-price">
              <strong>
                Total Price: $
                <span contentEditable={editTotalPrice} ref={totalPriceRef}>
                  {totalPrice ? totalPrice : "0"}
                </span>
                {!editTotalPrice && (
                  <FaEdit
                    className="service-package-edit-icon"
                    onClick={() => {
                      setTimeout(() => {
                        totalPriceRef.current.focus();
                      }, 0);
                      setEditTotalPrice(true);
                    }}
                    size={18}
                  />
                )}
              </strong>
            </div>
          </Col>
        </Row>
      </div>
      <div className="text-center">
        {packageToEdit !== null ? (
          <Button
            className="service-package-action-button primary"
            onClick={handleSaveEditedPackage}
          >
            Save Changes
          </Button>
        ) : (
          <Button
            className="service-package-action-button warning"
            onClick={handlePackageType}
          >
            {state?.invoice ? "Add to Invoice" : "Create Package"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ServicePackageCreation;
